import React, { useState, useEffect, useCallback } from 'react';
import Layout from '../components/Layout';
import api from '../api';

const Vehiculos = ({ usuario, onLogout }) => {
  const [vehiculos, setVehiculos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editando, setEditando] = useState(null);
  const [verInactivos, setVerInactivos] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({ placa: '', descripcion: '', capacidad_galones: '' });

  const esAdmin = usuario?.rol === 'admin';

  const cargar = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get('/vehiculos');
      setVehiculos(res.data);
    } catch {
      setError('Error cargando vehículos');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { cargar(); }, [cargar]);

  const resetForm = () => {
    setForm({ placa: '', descripcion: '', capacidad_galones: '' });
    setEditando(null);
    setShowForm(false);
    setError('');
  };

  const abrirEditar = (v) => {
    setForm({ placa: v.placa, descripcion: v.descripcion || '', capacidad_galones: v.capacidad_galones });
    setEditando(v.id);
    setShowForm(true);
  };

  const guardar = async (e) => {
    e.preventDefault();
    setError('');
    try {
      if (editando) {
        await api.put(`/vehiculos/${editando}`, form);
      } else {
        await api.post('/vehiculos', form);
      }
      resetForm();
      cargar();
    } catch (err) {
      setError(err.response?.data?.detail || 'Error guardando vehículo');
    }
  };

  const eliminar = async (id) => {
    if (!window.confirm('¿Desactivar este vehículo?')) return;
    try {
      await api.delete(`/vehiculos/${id}`);
      cargar();
    } catch {
      setError('Error desactivando vehículo');
    }
  };

  const restaurar = async (id) => {
    try {
      await api.patch(`/vehiculos/${id}/restaurar`);
      cargar();
    } catch {
      setError('Error restaurando vehículo');
    }
  };

  const activos = vehiculos.filter(v => v.activo);
  const inactivos = vehiculos.filter(v => !v.activo);
  const lista = verInactivos ? inactivos : activos;

  return (
    <Layout usuario={usuario} onLogout={onLogout} title="Vehículos">
      <div style={styles.headerRow}>
        <div style={styles.tabs}>
          <button style={{ ...styles.tabBtn, ...((!verInactivos) ? styles.tabActive : {}) }} onClick={() => setVerInactivos(false)}>
            Activos ({activos.length})
          </button>
          <button style={{ ...styles.tabBtn, ...(verInactivos ? styles.tabActive : {}) }} onClick={() => setVerInactivos(true)}>
            Inactivos ({inactivos.length})
          </button>
        </div>
        {esAdmin && !verInactivos && (
          <button style={styles.btnAdd} onClick={() => setShowForm(true)}>+ Nuevo Vehículo</button>
        )}
      </div>

      {error && <div style={styles.error}>{error}</div>}

      {showForm && (
        <div style={styles.formCard}>
          <h3 style={styles.formTitle}>{editando ? 'Editar Vehículo' : 'Nuevo Vehículo'}</h3>
          <form onSubmit={guardar} style={styles.form}>
            <div style={styles.formGrid}>
              <div style={styles.group}>
                <label style={styles.label}>Placa *</label>
                <input style={styles.input} value={form.placa} onChange={e => setForm({ ...form, placa: e.target.value.toUpperCase() })} placeholder="Ej: A123456" required />
              </div>
              <div style={styles.group}>
                <label style={styles.label}>Capacidad (galones) *</label>
                <input style={styles.input} type="number" step="0.01" value={form.capacidad_galones} onChange={e => setForm({ ...form, capacidad_galones: e.target.value })} placeholder="Ej: 5000" required />
              </div>
              <div style={{ ...styles.group, gridColumn: '1 / -1' }}>
                <label style={styles.label}>Descripción</label>
                <input style={styles.input} value={form.descripcion} onChange={e => setForm({ ...form, descripcion: e.target.value })} placeholder="Ej: Camión Mack cisterna grande" />
              </div>
            </div>
            <div style={styles.formBtns}>
              <button type="button" style={styles.btnCancel} onClick={resetForm}>Cancelar</button>
              <button type="submit" style={styles.btnSave}>{editando ? 'Guardar Cambios' : 'Crear Vehículo'}</button>
            </div>
          </form>
        </div>
      )}

      {loading ? (
        <div style={styles.loading}>Cargando...</div>
      ) : lista.length === 0 ? (
        <div style={styles.empty}>
          <div style={{ fontSize: '48px' }}>🚛</div>
          <p>{verInactivos ? 'No hay vehículos inactivos.' : 'No hay vehículos registrados.'}</p>
          {!verInactivos && esAdmin && <button style={styles.btnAdd} onClick={() => setShowForm(true)}>+ Agregar primer vehículo</button>}
        </div>
      ) : (
        <div style={styles.grid}>
          {lista.map(v => (
            <div key={v.id} style={{ ...styles.card, ...(v.activo ? {} : styles.cardInactivo) }}>
              <div style={styles.cardHeader}>
                <div style={styles.placa}>{v.placa}</div>
                {!v.activo && <span style={styles.badgeInactivo}>Inactivo</span>}
              </div>
              <div style={styles.cardBody}>
                <div style={styles.cardRow}>
                  <span style={styles.cardLabel}>⛽ Capacidad</span>
                  <span style={styles.cardVal}>{Number(v.capacidad_galones).toLocaleString()} gal</span>
                </div>
                {v.descripcion && (
                  <div style={styles.cardRow}>
                    <span style={styles.cardLabel}>📋 Descripción</span>
                    <span style={styles.cardVal}>{v.descripcion}</span>
                  </div>
                )}
              </div>
              {esAdmin && (
                <div style={styles.cardFooter}>
                  {v.activo ? (
                    <>
                      <button style={styles.btnEdit} onClick={() => abrirEditar(v)}>✏️ Editar</button>
                      <button style={styles.btnDel} onClick={() => eliminar(v.id)}>🗑️ Desactivar</button>
                    </>
                  ) : (
                    <button style={styles.btnRestore} onClick={() => restaurar(v.id)}>♻️ Restaurar</button>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </Layout>
  );
};

const styles = {
  headerRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '12px' },
  tabs: { display: 'flex', gap: '8px' },
  tabBtn: { padding: '8px 16px', borderRadius: '8px', border: '1.5px solid #e0e0e0', background: '#fff', color: '#666', fontSize: '13px', fontWeight: '600', cursor: 'pointer' },
  tabActive: { background: '#1a1a1a', color: '#fff', borderColor: '#1a1a1a' },
  btnAdd: { background: '#CC0000', color: '#fff', border: 'none', borderRadius: '8px', padding: '10px 18px', fontSize: '13px', fontWeight: '700', cursor: 'pointer' },
  error: { background: '#fff0f0', border: '1px solid #ffcccc', color: '#CC0000', padding: '10px 14px', borderRadius: '8px', fontSize: '13px', marginBottom: '16px' },
  formCard: { background: '#fff', borderRadius: '12px', padding: '24px', marginBottom: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', border: '1px solid #e0e0e0' },
  formTitle: { fontSize: '15px', fontWeight: '700', color: '#1a1a1a', margin: '0 0 16px' },
  form: { display: 'flex', flexDirection: 'column', gap: '16px' },
  formGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' },
  group: { display: 'flex', flexDirection: 'column', gap: '6px' },
  label: { fontSize: '12px', fontWeight: '600', color: '#555' },
  input: { padding: '10px 12px', borderRadius: '7px', border: '1.5px solid #e0e0e0', fontSize: '14px', outline: 'none', color: '#1a1a1a' },
  formBtns: { display: 'flex', gap: '10px', justifyContent: 'flex-end' },
  btnCancel: { padding: '10px 20px', borderRadius: '7px', border: '1.5px solid #e0e0e0', background: '#fff', color: '#666', fontSize: '13px', fontWeight: '600', cursor: 'pointer' },
  btnSave: { padding: '10px 20px', borderRadius: '7px', border: 'none', background: '#CC0000', color: '#fff', fontSize: '13px', fontWeight: '700', cursor: 'pointer' },
  loading: { textAlign: 'center', padding: '60px', color: '#666' },
  empty: { textAlign: 'center', padding: '60px', color: '#999', background: '#fff', borderRadius: '12px', border: '1px solid #e0e0e0' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '16px' },
  card: { background: '#fff', borderRadius: '12px', border: '1px solid #e0e0e0', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', overflow: 'hidden' },
  cardInactivo: { opacity: 0.6, borderStyle: 'dashed' },
  cardHeader: { background: '#1a1a1a', padding: '14px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  placa: { color: '#fff', fontSize: '18px', fontWeight: '800', letterSpacing: '1px', fontFamily: 'monospace' },
  badgeInactivo: { background: '#CC0000', color: '#fff', fontSize: '10px', fontWeight: '700', padding: '2px 8px', borderRadius: '10px' },
  cardBody: { padding: '16px', display: 'flex', flexDirection: 'column', gap: '10px' },
  cardRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '8px' },
  cardLabel: { fontSize: '12px', color: '#888', fontWeight: '500', flexShrink: 0 },
  cardVal: { fontSize: '13px', color: '#1a1a1a', fontWeight: '600', textAlign: 'right' },
  cardFooter: { padding: '12px 16px', borderTop: '1px solid #f0f0f0', display: 'flex', gap: '8px' },
  btnEdit: { flex: 1, padding: '8px', borderRadius: '6px', border: '1.5px solid #e0e0e0', background: '#fff', fontSize: '12px', fontWeight: '600', cursor: 'pointer', color: '#333' },
  btnDel: { flex: 1, padding: '8px', borderRadius: '6px', border: 'none', background: '#fff0f0', fontSize: '12px', fontWeight: '600', cursor: 'pointer', color: '#CC0000' },
  btnRestore: { flex: 1, padding: '8px', borderRadius: '6px', border: 'none', background: '#f0fff4', fontSize: '12px', fontWeight: '600', cursor: 'pointer', color: '#1a6b3a' },
};

export default Vehiculos;
